const visitorsEn = {
  "admin.visitors.text1": "bots",
  "admin.visitors.text2": "Bot",
  "admin.visitors.text3": "humans",
  "admin.visitors.text4": "all",
  "admin.visitors.text5": "IP unblocked (Cloudflare rule removed)",
  "admin.visitors.text6": "IP unblocked locally, but the Cloudflare rule could not be removed.",
  "admin.visitors.text7": "IP unblocked",
  "admin.visitors.text8": "Blocked — Cloudflare rule applied",
  "admin.visitors.text9": "Network blocking unavailable: Cloudflare is not configured or the API refused the request. The Actions (app) rule was applied.",
  "admin.visitors.text10": "Network (ASN) blocked",
  "admin.visitors.text11": "IP blocked",
  "admin.visitors.text12": "Network (ASN) blocked (Actions level)",
  "admin.visitors.text13": "IP blocked (Actions level)",
  "admin.visitors.text14": "Enriching ISP/ASN (may take 1–2 min)...",
  "admin.visitors.text15": "Error looking up the IP address",
  "admin.visitors.text16": "All logs successfully deleted",
  "admin.visitors.text17": "Error deleting logs",
  "admin.visitors.text18": "Loading...",
  "admin.visitors.text19": "Live visitors",
  "admin.visitors.text20": "IP insights",
  "admin.visitors.text21": "Enrich ISP/ASN",
  "admin.visitors.text22": "Clear all logs",
  "admin.visitors.text23": "Source:",
  "admin.visitors.text24": "Site visits",
  "admin.visitors.text25": "Link clicks",
  "admin.visitors.text26": "All",
  "admin.visitors.text27": "Active humans",
  "admin.visitors.text28": "Online now (excluding bots)",
  "admin.visitors.text29": "Humans today",
  "admin.visitors.text30": "Human visits",
  "admin.visitors.text31": "Bots today",
  "admin.visitors.text32": "Crawlers & visits",
  "admin.visitors.text33": "Country",
  "admin.visitors.text34": "Different countries",
  "admin.visitors.text35": "Visitors (grouped by IP)",
  "admin.visitors.text36": "Bot detection based on User-Agent (Cloudflare, Googlebot, GPTBot, etc.)",
  "admin.visitors.text37": "Humans (",
  "admin.visitors.text38": "Bots (",
  "admin.visitors.text39": "All (",
  "admin.visitors.text40": "No visitors",
  "admin.visitors.text41": "Status",
  "admin.visitors.text42": "IP",
  "admin.visitors.text43": "Browser",
  "admin.visitors.text44": "Fingerprint",
  "admin.visitors.text45": "Visits",
  "admin.visitors.text46": "Pages visited",
  "admin.visitors.text47": "First visit",
  "admin.visitors.text48": "Last activity",
  "admin.visitors.text49": "Actions",
  "admin.visitors.text50": "Online",
  "admin.visitors.text51": "Inactive",
  "admin.visitors.text52": "Verified",
  "admin.visitors.text53": "Reverse DNS confirmed",
  "admin.visitors.text54": "Unverified",
  "admin.visitors.text55": "The UA claims to be a known crawler but the reverse DNS does not match.",
  "admin.visitors.text56": "PTR:",
  "admin.visitors.text57": "Requests in the last 5 minutes",
  "admin.visitors.text58": "/5min",
  "admin.visitors.text59": "Lang:",
  "admin.visitors.text60": "CH:",
  "admin.visitors.text61": "Member(s) previously signed in from this IP",
  "admin.visitors.text62": "login",
  "admin.visitors.text63": "Possibly shared IP (NAT, VPN, data center).",
  "admin.visitors.text64": "Network:",
  "admin.visitors.text65": "Category:",
  "admin.visitors.text66": "· confidence",
  "admin.visitors.text67": "visit",
  "admin.visitors.text68": "page",
  "admin.visitors.text69": "Locate IP",
  "admin.visitors.text70": "Blocked",
  "admin.visitors.text71": " · Network",
  "admin.visitors.text72": " · Actions",
  "admin.visitors.text73": "Unblock IP",
  "admin.visitors.text74": "Verified crawler — cannot be blocked",
  "admin.visitors.text75": "Verified crawler, cannot be blocked",
  "admin.visitors.text76": "Block this IP (Actions)",
  "admin.visitors.text77": "Block completely (Cloudflare network)",
  "admin.visitors.text78": "Block ASN network (Actions)",
  "admin.visitors.text79": "Block ASN network completely (Cloudflare)",
  "admin.visitors.text80": "ASN blocked",
  "admin.visitors.text81": "Unblock",
  "admin.visitors.text82": "Block (Actions)",
  "admin.visitors.text83": "Block completely (network)",
  "admin.visitors.text84": "View full User-Agent",
  "admin.visitors.text85": "visited",
  "admin.visitors.text86": "Visits by hour (",
  "admin.visitors.text87": "Today's visit distribution",
  "admin.visitors.text88": "Browsers (",
  "admin.visitors.text89": "Breakdown by browser / bot",
  "admin.visitors.text90": "Most visited pages (",
  "admin.visitors.text91": "Top 5 today",
  "admin.visitors.text92": "No data",
  "admin.visitors.text93": "visits",
  "admin.visitors.text94": "Countries (",
  "admin.visitors.text95": "visitors",
  "admin.visitors.text96": "Block this network (ASN) completely?",
  "admin.visitors.text97": "Block this IP completely (network)?",
  "admin.visitors.text98": "Block this network (ASN) — Actions level?",
  "admin.visitors.text99": "Block this IP — Actions level?",
  "admin.visitors.text100": "This adds a Cloudflare rule blocking all site access",
  "admin.visitors.text101": "from the network",
  "admin.visitors.text102": "from IP",
  "admin.visitors.text103": "If Cloudflare is not configured, blocking will automatically fall back to the Actions level.",
  "admin.visitors.text104": "The network",
  "admin.visitors.text105": "will be blocked at the",
  "admin.visitors.text106": "(registration, contact, sign-in). Visits are still recorded. Verified crawlers are never blocked.",
  "admin.visitors.text107": "The IP",
  "admin.visitors.text108": "will be blocked at the",
  "admin.visitors.text109": "(registration, contact, sign-in). Visits are still recorded.",
  "admin.visitors.text110": "Cancel",
  "admin.visitors.text111": "Block completely",
  "admin.visitors.text112": "Block",
  "admin.visitors.text113": "IP geolocation information",
  "admin.visitors.text114": "Location details for the selected IP address",
  "admin.visitors.text115": "Looking up...",
  "admin.visitors.text116": "IP address",
  "admin.visitors.text117": "City",
  "admin.visitors.text118": "Region",
  "admin.visitors.text119": "Country code",
  "admin.visitors.text120": "Time zone",
  "admin.visitors.text121": "Internet service provider (ISP)",
  "admin.visitors.text122": "ASN",
  "admin.visitors.text123": "Confirm deletion",
  "admin.visitors.text124": "Are you sure you want to delete all visitor logs? This action cannot be undone.",
  "admin.visitors.text125": "Delete all",
  "admin.visitors.text126": "Full User-Agent",
  "admin.visitors.text127": "Raw string sent by the client",
  "admin.visitors.text128": "7 days",
  "admin.visitors.text129": "30 days",
  "admin.visitors.text130": "90 days",
  "admin.visitors.text131": "Suspicious",
  "admin.visitors.text132": "Needs attention",
  "admin.visitors.text133": "Normal",
  "admin.visitors.text134": "Error",
  "admin.visitors.text135": "Unable to load data",
  "admin.visitors.text136": "Checking permissions…",
  "admin.visitors.text137": "Access denied",
  "admin.visitors.text138": "This page is for administrators only.",
  "admin.visitors.text139": "IP insights & access",
  "admin.visitors.text140": "Compare (",
  "admin.visitors.text141": "Refresh",
  "admin.visitors.text142": "CSV (",
  "admin.visitors.text143": "The panel",
  "admin.visitors.text144": "Access & blocks",
  "admin.visitors.text145": "only lists IPs and ASNs with an existing rule (blocked or allowed). The insights table below only shows IPs with at least “Min visits” in the selected period — lower this threshold (e.g. to 1) to see a less active IP such as a single mobile visit.",
  "admin.visitors.text146": "Unique IPs",
  "admin.visitors.text147": "Returning (≥5 days)",
  "admin.visitors.text148": "Bots detected",
  "admin.visitors.text149": "\"Google-only\" (≥80%)",
  "admin.visitors.text150": "/inscription ≥3 without registering",
  "admin.visitors.text151": "Filters",
  "admin.visitors.text152": "IP, city, ISP, ASN…",
  "admin.visitors.text153": "Period",
  "admin.visitors.text154": "Min visits",
  "admin.visitors.text155": "Visitor type",
  "admin.visitors.text156": "All visitors",
  "admin.visitors.text157": "Humans only",
  "admin.visitors.text158": "Bots only",
  "admin.visitors.text159": "All countries",
  "admin.visitors.text160": "ISP",
  "admin.visitors.text161": "All ISPs",
  "admin.visitors.text162": "Hide signed-in members",
  "admin.visitors.text163": "IP(s) displayed",
  "admin.visitors.text164": "No IPs match these criteria.",
  "admin.visitors.text165": "Location",
  "admin.visitors.text166": "ISP / ASN",
  "admin.visitors.text167": "Sessions",
  "admin.visitors.text168": "Days",
  "admin.visitors.text169": "Google",
  "admin.visitors.text170": "/inscription",
  "admin.visitors.text171": "Score",
  "admin.visitors.text172": "Latest",
  "admin.visitors.text173": "Browser with a proven authenticated sign-in",
  "admin.visitors.text174": "Authenticated sign-in confirmed",
  "admin.visitors.text175": "IP copied",
  "admin.visitors.text176": "Unknown ISP",
  "admin.visitors.text177": "Active days",
  "admin.visitors.text178": "Google %",
  "admin.visitors.text179": "Daily activity",
  "admin.visitors.text180": "Top pages",
  "admin.visitors.text181": "Top referrers",
  "admin.visitors.text182": "(direct)",
  "admin.visitors.text183": "User agents (",
  "admin.visitors.text184": "First visit:",
  "admin.visitors.text185": "Latest:",
  "admin.visitors.text186": "Comparison (",
  "admin.visitors.text187": "IPs)",
  "admin.visitors.text188": "Side-by-side comparison of key metrics",
  "admin.visitors.text189": "Top pages:",
  "admin.visitors.text190": "Deselect all",
  "admin.visitors.text191": "Present on ≥ 5 distinct days",
  "admin.visitors.text192": "More than 20 visits in total",
  "admin.visitors.text193": "≥ 80% of traffic comes from Google",
  "admin.visitors.text194": "At least 3 views of /inscription",
  "admin.visitors.text195": "Corporate ISP / flagged hosting provider",
  "admin.visitors.text196": "Identified member (trust bonus)",
  "admin.visitors.text197": "Registration form view",
  "admin.visitors.text198": "Authentication page",
  "admin.visitors.text199": "Verification link clicked",
  "admin.visitors.text200": "Admin area access",
  "admin.visitors.text201": "Member area access",
  "admin.visitors.text202": "Contact page",
  "admin.visitors.text203": "IP identity header",
  "admin.visitors.text204": "KPIs (visits, sessions, etc.)",
  "admin.visitors.text205": "📊 Why this score?",
  "admin.visitors.text206": "📈 Daily activity (chart)",
  "admin.visitors.text207": "🚨 Key events",
  "admin.visitors.text208": "🕷️ Bots & Turnstile challenges",
  "admin.visitors.text209": "🕒 Full timeline",
  "admin.visitors.text210": "accept-encoding without gzip/br/deflate → non-browser client",
  "admin.visitors.text211": "empty accept-language → likely script",
  "admin.visitors.text212": "If-Modified-Since / ETag present → repeated visit pattern",
  "admin.visitors.text213": "Automated tool User-Agent detected",
  "admin.visitors.text214": "Consistent browser profile (known UA + Brotli support)",
  "admin.visitors.text215": "Inspection updated",
  "admin.visitors.text216": "Failed",
  "admin.visitors.text217": "Day",
  "admin.visitors.text218": "Key events",
  "admin.visitors.text219": "Date",
  "admin.visitors.text220": "Type",
  "admin.visitors.text221": "Label",
  "admin.visitors.text222": "URL",
  "admin.visitors.text223": "Detail",
  "admin.visitors.text224": "Bots & Turnstile challenges",
  "admin.visitors.text225": "User-Agent",
  "admin.visitors.text226": "Metadata",
  "admin.visitors.text227": "Full timeline",
  "admin.visitors.text228": "Page",
  "admin.visitors.text229": "Referrer",
  "admin.visitors.text230": "Session",
  "admin.visitors.text231": "HTML export generated",
  "admin.visitors.text232": "No tabular data",
  "admin.visitors.text233": "Select at least one tabular section containing data.",
  "admin.visitors.text234": "CSV export generated",
  "admin.visitors.text235": "Access restricted to administrators.",
  "admin.visitors.text236": "IP details",
  "admin.visitors.text237": "Collectif Ibbü · Insights report",
  "admin.visitors.text238": "IP activity report",
  "admin.visitors.text239": "Generated on:",
  "admin.visitors.text240": "IP ID:",
  "admin.visitors.text241": "Period:",
  "admin.visitors.text242": "Back to IP insights",
  "admin.visitors.text243": "Export as PDF",
  "admin.visitors.text244": "Sections to include",
  "admin.visitors.text245": "Choose what will appear in the PDF.",
  "admin.visitors.text246": "Select all",
  "admin.visitors.text247": "Deselect all",
  "admin.visitors.text248": "File name",
  "admin.visitors.text249": "Generate PDF",
  "admin.visitors.text250": "Alternative exports (tabular sections)",
  "admin.visitors.text251": "HTML",
  "admin.visitors.text252": "CSV",
  "admin.visitors.text253": "HTML includes a report header. CSV only contains the selected tabular sections (daily activity, events, bots, timeline).",
  "admin.visitors.text254": "Authenticated sign-in confirmed (no identifiable account)",
  "admin.visitors.text255": "Unknown location",
  "admin.visitors.text256": "Visits / day",
  "admin.visitors.text257": "Transparent breakdown of applied rules (max 100).",
  "admin.visitors.text258": "Final score / 100",
  "admin.visitors.text259": "Detailed behavior",
  "admin.visitors.text260": "Top URLs, bursts, sensitive resources, heatmap (30 days).",
  "admin.visitors.text261": "No data.",
  "admin.visitors.text262": "Hits",
  "admin.visitors.text263": "Unique pages",
  "admin.visitors.text264": "Crawl ratio",
  "admin.visitors.text265": "Bursts (≥3 hits < 2s)",
  "admin.visitors.text266": "Sensitive resource access",
  "admin.visitors.text267": "Top 20 URLs",
  "admin.visitors.text268": "Detected bursts",
  "admin.visitors.text269": "hits",
  "admin.visitors.text270": "duration",
  "admin.visitors.text271": "sequential crawl",
  "admin.visitors.text272": "Day × hour heatmap (30 days, Europe/Paris)",
  "admin.visitors.text273": "HTTP signature",
  "admin.visitors.text274": "Headers captured on visit requests. Inspection:",
  "admin.visitors.text275": "enabled",
  "admin.visitors.text276": "disabled",
  "admin.visitors.text277": "Disable inspection",
  "admin.visitors.text278": "Enable inspection",
  "admin.visitors.text279": "No captures. Enable inspection and wait for the next request from this IP.",
  "admin.visitors.text280": "Latest capture:",
  "admin.visitors.text281": "capture(s) in total",
  "admin.visitors.text282": "Headers come from a cross-origin XHR to an Edge Function. Client Hints (",
  "admin.visitors.text283": "sec-ch-ua*",
  "admin.visitors.text284": ") and first-party cookies are not sent in this context — their absence is normal and",
  "admin.visitors.text285": "is not a bot signal",
  "admin.visitors.text286": "✓ No abnormal signals — profile consistent with a real browser.",
  "admin.visitors.text287": "View raw headers (latest capture)",
  "admin.visitors.text288": "📈 Daily activity (last 30 days)",
  "admin.visitors.text289": "🚨 Key events (",
  "admin.visitors.text290": "Sensitive actions detected on this IP (up to 100 shown).",
  "admin.visitors.text291": "No sensitive events detected.",
  "admin.visitors.text292": "🕷️ Bots & Turnstile challenges (",
  "admin.visitors.text293": "Blocked",
  "admin.visitors.text294": ": scrapers/archivers.",
  "admin.visitors.text295": "Allowed",
  "admin.visitors.text296": ": AI crawlers.",
  "admin.visitors.text297": "Challenge",
  "admin.visitors.text298": ": Turnstile captcha required / passed / failed.",
  "admin.visitors.text299": "No bot or challenge events for this IP.",
  "admin.visitors.text300": "Signature / Reason",
  "admin.visitors.text301": "Details",
  "admin.visitors.text302": "Allowed (AI)",
  "admin.visitors.text303": "Challenge required",
  "admin.visitors.text304": "Challenge passed",
  "admin.visitors.text305": "Challenge failed",
  "admin.visitors.text306": "same URL:",
  "admin.visitors.text307": "total:",
  "admin.visitors.text308": "🕒 Full timeline (",
  "admin.visitors.text309": "entries)",
  "admin.visitors.text310": "All page views from this IP, newest first.",
  "admin.visitors.text311": "Short link clicks by IP",
  "admin.visitors.text312": "Who clicked your links, grouped by IP address. One IP may include several browsers: open it to see each click’s status.",
  "admin.visitors.text313": "12 months",
  "admin.visitors.text314": "Filter by IP",
  "admin.visitors.text315": "No link clicks recorded in this period.",
  "admin.visitors.text316": "unknown link",
  "admin.visitors.text317": "click(s)",
  "admin.visitors.text318": "visitor(s)",
  "admin.visitors.text319": "identifier(s) ·",
  "admin.visitors.text320": "verified",
  "admin.visitors.text321": "link(s)",
  "admin.visitors.text322": "VPN",
  "admin.visitors.text323": "Private browsing",
  "admin.visitors.text324": "Short link clicks (",
  "admin.visitors.text325": "browser identifier(s) observed from this IP address, including",
  "admin.visitors.text326": "verified. One IP can include several browsers: status is shown for each click.",
  "admin.visitors.text327": "No link clicks from this IP.",
  "admin.visitors.text328": "Bot",
  "admin.visitors.text329": "Unknown device",
  "admin.visitors.text330": "direct",
  "admin.visitors.text331": "Visitor:",
  "admin.visitors.text332": "Network blocked ({label}) — level {scope}",
  "admin.visitors.text333": "Backfill complete: {rows} rows updated ({resolved}/{total} IPs resolved).",
  "admin.visitors.text334": "Referrer",
  "admin.visitors.text335": "Limited to the 500 most recent entries",
  "admin.visitors.text336": "Accounts associated with browsers observed from this IP: {name}",
  "admin.visitors.text337": "Observed accounts: {name}",
  "admin.visitors.text338": "{count} active day(s)",
  "admin.visitors.text339": "{count} visit(s)",
  "admin.visitors.text340": "{count}% from Google",
  "admin.visitors.text341": "{count} view(s) /inscription",
  "admin.visitors.text342": "{count} section(s) exported.",
  "admin.visitors.text343": "Accounts associated with observed browsers: {name}",
  "admin.visitors.text344": "Sun",
  "admin.visitors.text345": "Mon",
  "admin.visitors.text346": "Tue",
  "admin.visitors.text347": "Wed",
  "admin.visitors.text348": "Thu",
  "admin.visitors.text349": "Fri",
  "admin.visitors.text350": "Sat",
  "admin.visitors.text351": "MM/dd/yyyy 'at' HH:mm",
  "admin.visitors.text352": "IP visits report",
  "admin.visitors.text353": "Collectif Ibbü · Visits report",
  "admin.visitors.text354": "IP activity report —",
  "admin.visitors.text355": "Generated on",
  "admin.visitors.text356": "Page ",
  "admin.visitors.text357": "{count} d",
  "admin.visitors.text358": " · confidence {value}",
  "admin.visitors.text359": " · request {id}"
} as const;

export default visitorsEn;
